<textarea truncateString (valueTruncateChange)="onChange($event)" [placeholder]="placeholder" [(ngModel)]="value" (focus)="onfocus($event)"(blur)="onBlur($event)" (keydown)="onKeydown($event)"
     rows="1" (ngModelChange)="onChange($event)" [(valueTruncate)]="value" requireds>
</textarea>
